const BASE_API = process.env.REACT_APP_ROUTE_API;

const getHeaders = () => {
  const token = localStorage.getItem('token');

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};

export default {
  listar: async (rankingCompeticaoId) => {
    try {
        const req = await fetch(
            `${BASE_API}ranking/${rankingCompeticaoId}`,
            {
            method: 'GET',
            headers: getHeaders(),
            }
        );
        const json = await req.json();
        json.data = json.data ?? [];
        json.statusRetorno = req.status;

        return json;
    }  catch (error) {
      return error;
    }
  },
  html: async (rankingCompeticaoId) => {
    try {
        const req = await fetch(
            `${BASE_API}ranking/${rankingCompeticaoId}/html`,
            {
            method: 'GET',
            headers: getHeaders(),
            }
        );
        const json = await req.json();
        json.data = json.data ?? [];
        json.statusRetorno = req.status;

        return json;
    }  catch (error) {
      return error;
    }
  },

  exportarExcel: async (rankingCompeticaoId) => {
    try {
        const req = await fetch(
            `${BASE_API}ranking/${rankingCompeticaoId}/excel`,
            {
            method: 'GET',
            headers: getHeaders(),
            }
        );
        const json = await req.json();
        json.data = json.data ?? [];
        json.statusRetorno = req.status;

        return json;
    }  catch (error) {
      return error;
    }
  },

  exportarPdf: async (rankingCompeticaoId) => {
    try {
        const req = await fetch(
            `${BASE_API}ranking/${rankingCompeticaoId}/pdf`,
            {
            method: 'GET',
            headers: getHeaders(),
            }
        );
        const json = await req.json();
        json.data = json.data ?? [];
        json.statusRetorno = req.status;

        return json;
    }  catch (error) {
      return error;
    }
  },
  listarAnos: async () => {
    try {
      const req = await fetch(`${BASE_API}ranking/anos`, {
        method: 'GET',
        headers: getHeaders(),
      });

      const json = await req.json();
      json.data = json.data ?? [];
      json.statusRetorno = req.status;

      return json;
    } catch (error) {
      return error;
    }
  },
  listarFiltros: async (ano, modalidade) => {
    try {
      const req = await fetch(
        `${BASE_API}ranking/${ano}/${modalidade}/filtros`, {
          method: 'GET',
          headers: getHeaders(),
        });

      const json = await req.json();
      
      json.data = json.data ?? {};
      json.statusRetorno = req.status;

      return json;
    } catch (error) {
      return error;
    }
  },
  listarPorAno: async (ano, modalidade, filtros = {}) => {
    try {
      const params = new URLSearchParams();

      const filtrosPermitidos = modalidade === 'gyeorugi'
        ? ['sexo', 'divisao', 'peso']
        : ['categoria', 'faixa'];

      filtrosPermitidos.forEach((campo) => {
        const valor = filtros[campo];

        if (valor !== undefined && valor !== null && valor !== '') {
          params.append(campo, valor);
        }
      });

      const queryString = params.toString();

      const url = `${BASE_API}ranking/${ano}/${modalidade}/classificacao${
        queryString ? `?${queryString}` : ''
      }`;

      const req = await fetch(url, {
        method: 'GET',
        headers: getHeaders(),
      });

      const json = await req.json();

      json.data = json.data ?? {};
      json.statusRetorno = req.status;

      return json;
    } catch (error) {
      console.error('Erro ao consultar ranking:', error);
      return error;
    }
  },
  listarAcademiasPorAno: async (ano) => {
    try {
      const req = await fetch(
        `${BASE_API}ranking/${ano}/academias`,
        {
          method: 'GET',
          headers: getHeaders(),
        }
      );

      const json = await req.json();

      json.data = json.data ?? [];
      json.statusRetorno = req.status;

      return json;
    } catch (error) {
      return error;
    }
  },
};
